export enum OperationTypeEnum {
    GRN = 'GRN',
    BE_HEADING = 'DE HEADING',
    GRADING = 'GRADING',
    VALUE_ADDITION = 'VALUE ADDITION',
    SOAKING = 'SOAKING',
    FREEZING = 'FREEZING',
    PACKING = 'PACKING',
    NO_OPERATION = 'NO OPERATION',
    TOFF = 'TOFF',
    PD = 'PD',
    RPDTON = 'RPDTON',
    COOKING='COOKING',
}